import axiosInstance from '../../lib/axios';

export const fetchReviewQueue = async ({ type, page, limit }) => {
  const response = await axiosInstance.get('/admin/review/queue/', {
    params: { type, page, limit },
  });
  return response.data;
};

export const fetchReviewSummary = async () => {
  const response = await axiosInstance.get('/admin/review/summary/');
  return response.data;
};

// One call for one or many ids; the server reports decided / blocked / missing per id.
export const reviewDecide = async ({ type, ids, decision, comment }) => {
  const response = await axiosInstance.post('/admin/review/decide/', {
    type,
    ids,
    decision,
    comment: comment || undefined,
  });
  return response.data;
};
